const S = (u) => {
  const { viewer: e, bundle: w } = u, c = async () => {
    const o = /* @__PURE__ */ new Map();
    return await l(async (t) => {
      const i = await e.model.getNodeProperties(t);
      i && i.xom_uuid && o.set(i.xom_uuid.trim(), t);
    }), o;
  }, l = async (o) => {
    const t = async (i) => (await o(i), Promise.all(e.model.getNodeChildren(i).map(t)));
    await t(e.model.getAbsoluteRootNode());
  }, h = async (o) => {
    const t = await c();
    o.forEach((i) => {
      const n = t.get(i.xomUuid);
      n && (i.edgeIds.forEach((a) => {
        e.model.setNodeLineHighlighted(n, a, !0);
      }), i.faceIds.forEach((a) => {
        e.model.setNodeFaceHighlighted(n, a, !0);
      }));
    });
  }, d = async () => {
    await e.model.resetModelHighlight();
  }, C = async (o, t) => {
    await e.view.setBackgroundColor(
      new Communicator.Color(...o),
      new Communicator.Color(...t)
    );
  }, f = (o) => {
    e.selectionManager.setSelectParentIfSelected(!1), e.setCallbacks({
      selectionArray: (t) => {
        const i = t[0];
        if (!i)
          return;
        const a = i.getSelection().getNodeId();
        typeof a == "number" && e.model.getNodeProperties(a).then((r) => {
          r && r.xom_uuid && o(r.xom_uuid.trim());
        });
      }
    }), e.selectionManager.setSelectionFilter((t) => (e.selectionManager.clear(), t));
  }, y = (o) => {
    e.selectionManager.setSelectionFilter((t, i) => o ? t : null);
  }, v = async (o) => {
    o ? await e.view.getNavCube().enable() : await e.view.getNavCube().disable();
  }, p = async (o) => {
    o ? await e.view.getAxisTriad().enable() : await e.view.getAxisTriad().disable();
  }, M = () => e.resizeCanvas(), N = async (o) => {
    const { face: t, line: i } = o;
    await Promise.all([
      e.model.setNodesFaceColor([e.model.getAbsoluteRootNode()], new Communicator.Color(...t)),
      e.model.setNodesLineColor([e.model.getAbsoluteRootNode()], new Communicator.Color(...i))
    ]);
  }, m = (o) => {
    const { face: t, line: i } = o;
    e.model._engine.setElementHighlightColor(new Communicator.Color(...t), new Communicator.Color(...i));
  };
  return {
    forEachModelNode: l,
    clearHighlight: d,
    highlightNodes: h,
    setBackgroundColor: C,
    highlightPartId: async (o) => {
      const i = (await c()).get(o);
      if (!i)
        return;
      await d(), await e.view.setDrawMode(Communicator.DrawMode.XRay), await e.view.setXRayOpacity(1, Communicator.ElementType.Lines);
      const n = [175, 196, 201];
      m({ face: n, line: n });
      const a = await e.model.getFaceCount(i);
      for (let s = 0; s < a; s += 1)
        await e.model.setNodeFaceHighlighted(i, s, !0);
      const r = await e.model.getEdgeCount(i);
      for (let s = 0; s < r; s += 1)
        await e.model.setNodeLineHighlighted(i, s, !0);
    },
    setAssemblyPartClickToSelect: f,
    setClickToSelect: y,
    setShowNavCube: v,
    setShowAxisTriad: p,
    resizeCanvas: M,
    setColor: N,
    setHighlightColor: m,
    setLineVisibility: async (o) => {
      await e.view.setLineVisibility(o);
    },
    shutdown: () => e.shutdown(),
    getDefaultMaxZoom: async () => {
      const t = (await e.model.getModelBounding(!0, !0)).extents();
      return Math.max(t.x, t.y, t.z) * 7;
    },
    doZoom: (o, t, i) => {
      const n = e.view.getCamera(), a = n.getWidth() > o || n.getHeight() > o, r = t > 1;
      a && r || (n.setWidth(n.getWidth() * t), n.setHeight(n.getHeight() * t), e.view.setCamera(n, i));
    },
    customizeZoom: () => {
      const o = e.operatorManager.getOperator(w.OperatorId.Zoom);
      o.setZoomToMousePosition(!1);
      const i = o._doZoom.bind(o);
      o._doZoom = (n, ...a) => {
        const s = e.view.getCamera().getHeight(), g = n < 0;
        g && s < 1 || !g && s > 300 || i(n, ...a);
      };
    },
    getFileType: () => {
      const o = e.model.getAbsoluteRootNode(), i = e.model.getNodeChildren(o)[0];
      return e.model.getModelFileTypeFromNode(i);
    },
    viewer: e
  };
};
export {
  S as getHoopsViewerApi
};
//# sourceMappingURL=HoopsViewer.api.mjs.map
